import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Flex,
  HStack,
  Input,
  Select,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Badge,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from '@chakra-ui/react';
import { AddIcon } from '@chakra-ui/icons';
import axiosInstance from '../../../api/AxiosInstance';
import FormularioBeneficiario from './FormularioBeneficiario';

const TablaBeneficiarios: React.FC = () => {
  const { isOpen: isOpenVer, onOpen: onOpenVer, onClose: onCloseVer } = useDisclosure();
  const { isOpen: isOpenEditar, onOpen: onOpenEditar, onClose: onCloseEditar } = useDisclosure();
  const { isOpen: isOpenNuevo, onOpen: onOpenNuevo, onClose: onCloseNuevo } = useDisclosure();

  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [data, setData] = useState<any[]>([]);
  const [cargando, setCargando] = useState(false);
  const [filtroCurp, setFiltroCurp] = useState('');
  const [filtroLocalidad, setFiltroLocalidad] = useState('');
  const [filtroEstatus, setFiltroEstatus] = useState('');

  const fetchData = async () => {
    setCargando(true);
    try {
      const params = new URLSearchParams();
      if (filtroCurp) params.append('curp', filtroCurp);
      if (filtroLocalidad) params.append('localidadId', filtroLocalidad);
      if (filtroEstatus) params.append('estatus', filtroEstatus);
      const res = await axiosInstance.get(`/desarrollo-social/beneficiarios?${params.toString()}`);
      setData(res.data || []);
    } catch {
      setData([]);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleVer = async (item: any) => {
    try {
      const res = await axiosInstance.get(`/desarrollo-social/beneficiarios/${item.id}`);
      setSelectedItem(res.data);
    } catch {
      setSelectedItem(item);
    }
    onOpenVer();
  };

  const handleEditar = (item: any) => {
    setSelectedItem(item);
    onOpenEditar();
  };

  const handleEliminar = async (item: any) => {
    const ok = window.confirm(`Eliminar beneficiario ${item.nombreCompleto}?`);
    if (!ok) return;
    try {
      await axiosInstance.delete(`/desarrollo-social/beneficiarios/${item.id}`);
      fetchData();
    } catch {
      // noop
    }
  };

  const handleGuardado = () => {
    onCloseNuevo();
    onCloseEditar();
    fetchData();
  };

  return (
    <Box>
      <Flex mb={4} justify="space-between" align="center" flexWrap="wrap" gap={3}>
        <HStack spacing={3} flexWrap="wrap">
          <Input
            placeholder="CURP"
            value={filtroCurp}
            onChange={(e) => setFiltroCurp(e.target.value)}
            size="sm"
            w={{ base: 'full', md: '200px' }}
          />
          <Input
            placeholder="Localidad ID"
            value={filtroLocalidad}
            onChange={(e) => setFiltroLocalidad(e.target.value)}
            size="sm"
            w={{ base: 'full', md: '160px' }}
          />
          <Select
            placeholder="Estatus"
            value={filtroEstatus}
            onChange={(e) => setFiltroEstatus(e.target.value)}
            size="sm"
            w="160px"
          >
            <option value="aprobado">Aprobado</option>
            <option value="no_aprobado">No aprobado</option>
            <option value="pendiente">Pendiente</option>
          </Select>
          <Button size="sm" onClick={fetchData} variant="outline">Filtrar</Button>
        </HStack>
        <Button size="sm" leftIcon={<AddIcon />} bg="#5b182b" color="white" _hover={{ bg: '#691f30' }} onClick={onOpenNuevo}>
          Nuevo beneficiario
        </Button>
      </Flex>

      <Box overflowX="auto" borderRadius="md" boxShadow="md" bg="white">
        <Table variant="simple" size="sm">
          <Thead bg="#5b182b">
            <Tr>
              <Th color="white" fontSize="xs">Folio</Th>
              <Th color="white" fontSize="xs">Nombre</Th>
              <Th color="white" fontSize="xs">CURP</Th>
              <Th color="white" fontSize="xs">Telefono</Th>
              <Th color="white" fontSize="xs">Estatus</Th>
              <Th color="white" fontSize="xs">Acciones</Th>
            </Tr>
          </Thead>
          <Tbody>
            {cargando ? (
              <Tr><Td colSpan={6} textAlign="center" py={8}><Text color="gray.500">Cargando...</Text></Td></Tr>
            ) : data.length === 0 ? (
              <Tr><Td colSpan={6} textAlign="center" py={8}><Text color="gray.400">Sin registros</Text></Td></Tr>
            ) : (
              data.map((item, idx) => (
                <Tr key={item.id} bg={idx % 2 === 0 ? 'white' : 'gray.50'} _hover={{ bg: 'teal.50' }}>
                  <Td>{item.folio}</Td>
                  <Td maxW="220px"><Text noOfLines={1} title={item.nombreCompleto}>{item.nombreCompleto}</Text></Td>
                  <Td>{item.curp}</Td>
                  <Td>{item.telefono}</Td>
                  <Td><Badge colorScheme={item.estatus === 'aprobado' ? 'green' : item.estatus === 'no_aprobado' ? 'red' : 'yellow'}>{item.estatus}</Badge></Td>
                  <Td>
                    <HStack spacing={1}>
                      <Button size="xs" colorScheme="blue" variant="outline" onClick={() => handleVer(item)}>Ver</Button>
                      <Button size="xs" colorScheme="orange" variant="outline" onClick={() => handleEditar(item)}>Editar</Button>
                      <Button size="xs" colorScheme="red" variant="outline" onClick={() => handleEliminar(item)}>Eliminar</Button>
                    </HStack>
                  </Td>
                </Tr>
              ))
            )}
          </Tbody>
        </Table>
      </Box>

      <Modal isOpen={isOpenVer} onClose={onCloseVer} size="6xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius="xl" overflow="hidden">
          <ModalHeader borderBottom="1px solid" borderColor="gray.200" color="#5b182b" bg="gray.50">Detalle del beneficiario</ModalHeader>
          <ModalBody py={5} bg="white">
            {selectedItem && <FormularioBeneficiario modo="view" data={selectedItem} />}
          </ModalBody>
          <ModalFooter borderTop="1px solid" borderColor="gray.100" bg="gray.50">
            <Button onClick={onCloseVer}>Cerrar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenEditar} onClose={onCloseEditar} size="6xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius="xl" overflow="hidden">
          <ModalHeader borderBottom="1px solid" borderColor="gray.200" color="#5b182b" bg="gray.50">Editar beneficiario</ModalHeader>
          <ModalBody py={5} bg="white">
            {selectedItem && <FormularioBeneficiario modo="edit" data={selectedItem} onGuardado={handleGuardado} onCancelar={onCloseEditar} />}
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenNuevo} onClose={onCloseNuevo} size="6xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius="xl" overflow="hidden">
          <ModalHeader borderBottom="1px solid" borderColor="gray.200" color="#5b182b" bg="gray.50">Nuevo beneficiario</ModalHeader>
          <ModalBody py={5} bg="white">
            <FormularioBeneficiario modo="new" onGuardado={handleGuardado} onCancelar={onCloseNuevo} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default TablaBeneficiarios;


